import { render } from "./AssessmentProfileLayoutHeading.vue?vue&type=template&id=333ede46&scoped=true"
import script from "./AssessmentProfileLayoutHeading.vue?vue&type=script&lang=js"
export * from "./AssessmentProfileLayoutHeading.vue?vue&type=script&lang=js"

import "./AssessmentProfileLayoutHeading.vue?vue&type=style&index=0&id=333ede46&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-333ede46"

export default script